// Scripts
import toastr from 'toastr'
import Captcha from '../libs/captcha3'
import IMask from 'imask'
import Pristine from 'pristinejs'
import { loading, extend } from '../libs/utils.js'

// Styles
import '../../scss/components/forms'
import '../../scss/components/toast'

// Setup
const settings = require('../../common.json')
const nJsonData = require('../../forms.json')
settings.messages = extend(true, nJsonData.messages, settings.messages) // étend les options

const Forms = {

  execute (form, pristineForm) {
    loading(form)
    form.classList.remove('was-validated')
    toastr.remove()
    toastr.info(settings.messages.forms.sending, '', { closeButton: false, timeOut: 9999999 })
    const data = new FormData()
    const fields = Array.from(form.elements)
    data.append('form', form.getAttribute('data-formid'))
    fields.forEach(field => {
      if (field.getAttribute('name') && field.getAttribute('name') !== 'recaptcha3') {
        if (field.getAttribute('type') === 'checkbox') {
          if (field.hasAttribute('role') && field.getAttribute('role') === 'switch') {
            data.append(field.getAttribute('name'), field.checked ? 'Oui' : 'Non')
          } else {
            if (field.checked) { data.append(field.getAttribute('name'), field.value) }
          }
        } else if (field.getAttribute('type') === 'file') {
          data.append(field.getAttribute('name'), field.files[0])
        } else {
          data.append(field.getAttribute('name'), field.value)
        }
      }
    })
    if (form.hasAttribute('enctype')) {
      fetch(document.location.origin + '/form/send', {
        method: 'POST',
        headers: new Headers({
          'X-Requested-With': 'XMLHttpRequest'
        }),
        body: data
      }).then(response => {
        if (response.status === 200) {
          response.json().then(data => {
            toastr.remove()
            const message = data.success !== '' ? data.success : settings.messages.forms.successSend
            toastr.success(message, '', { closeButton: true, timeOut: 50000, newestOnTop: true })
          })
          // reset les formulaires uniquement à l'ajout
          form.reset()
          pristineForm.reset()
          /* global gtag */
          if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { type: 'submit' }) }
        } else {
          toastr.remove()
          toastr.error(settings.messages.errors.retry)
        }
        loading(form, false)
      })
    } else {
      fetch(document.location.origin + '/form/send', {
        method: 'POST',
        headers: new Headers({
          'X-Requested-With': 'XMLHttpRequest'
        }),
        body: data
      }).then(response => {
        if (response.status === 200) {
          response.json().then(data => {
            toastr.remove()
            const message = data.success !== '' ? data.success : settings.messages.forms.successSend
            toastr.success(message, '', { closeButton: true, timeOut: 50000, newestOnTop: true })
          })
          // reset les formulaires uniquement à l'ajout
          form.reset()
          pristineForm.reset()
          if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { type: 'submit' }) }
        } else {
          toastr.remove()
          toastr.error(settings.messages.errors.retry)
        }
        loading(form, false)
      })
    }
  },

  initForm (form) {
    const self = this

    // extension check function
    const checkExtFn = (e) => {
      // récupère les extensions autorisées selon l'attribut accept
      if (e.target.getAttribute('accept') && e.target.getAttribute('accept') !== '') {
        const types = e.target.getAttribute('accept').split(',')
        const extensions = []
        types.forEach(type => {
          const format = type.split('/')
          extensions.push(format[1])
        })
        self.checkFileExtension(e.target, extensions)
      } else {
        self.checkFileExtension(e.target)
      }
    }

    // si on détecte un champ input[type="file"], on ajoute un enctype="multipart/form-data" au formulaire
    const fields = Array.from(form.elements)
    let isMultipart = false
    fields.forEach(field => {
      if (field.getAttribute('name')) {
        if (field.getAttribute('type') === 'file') {
          isMultipart = true
          // ajoute un contrôle de l'extension
          field.addEventListener('change', checkExtFn)
        }
      }
    })
    if (isMultipart === true) {
      form.setAttribute('enctype', 'multipart/form-data')
    }

    // form validation
    const pristineForm = new Pristine(form, {
      classTo: 'required',
      errorClass: 'error',
      errorTextParent: 'required'
    })

    // form masks
    form.querySelectorAll('.phone').forEach(field => {
      IMask(field, { mask: '00-00-00-00-00' })
    })
    form.querySelectorAll('.email').forEach(field => {
      IMask(field, { mask: /[\w@\-.+]/ })
    })
    form.querySelectorAll('.zip').forEach(field => {
      IMask(field, { mask: Number })
    })
    form.querySelectorAll('.number').forEach(field => {
      IMask(field, { mask: Number })
    })

    // recaptcha antispam check
    const captcha = new Captcha(form, {
      action: 'contact',
      onSuccess () {
        loading(form)
        self.execute(form, pristineForm)
      },
      onError () {
        loading(form, false)
        toastr.error(settings.messages.errors.retry)
      },
      onCancel () {
        loading(form, false)
      }
    })

    // submit function
    const submitFn = (e) => {
      e.preventDefault()
      if (pristineForm.validate()) {
        loading(form)
        captcha.verify()
      }
      form.classList.add('was-validated')
    }
    form.addEventListener('submit', submitFn)
  },

  checkFileExtension (inputEl, fileExtension = ['pdf']) {
    if (window.FileReader && window.Blob) {
      const files = inputEl.files
      for (let i = 0; i < files.length; i++) {
        const blob = files[i]
        const fileReader = new FileReader()
        fileReader.onloadend = (e) => {
          const arr = (new Uint8Array(e.target.result)).subarray(0, 4)
          let header = ''
          let type = ''
          for (let i = 0; i < arr.length; i++) {
            header += arr[i].toString(16)
          }
          // Check the file signature against known types : https://en.wikipedia.org/wiki/List_of_file_signatures
          // https://stackoverflow.com/questions/18299806/how-to-check-file-mime-type-with-javascript-before-upload
          switch (header) {
            case '25504446':
              type = 'pdf'
              break
            case '89504e47':
              type = 'png'
              break
            case '47494638':
              type = 'gif'
              break
            case 'ffd8ffe0':
            case 'ffd8ffe1':
            case 'ffd8ffe2':
            case 'ffd8ffe3':
            case 'ffd8ffe8':
              type = 'jpeg'
              break
            default:
              type = 'unknown' // Or you can use the blob.type as fallback
          }
          if (type === 'unknown' || fileExtension.indexOf(type) === -1) {
            alert('Format de fichier non autorisé : ' + fileExtension.join(', '))
            inputEl.value = ''
          }
        }
        fileReader.readAsArrayBuffer(blob)
      }
    } else {
      const inputVal = inputEl.value
      if (fileExtension.indexOf(inputVal.split('.').pop().toLowerCase()) === -1) {
        alert('Format de fichier non autorisé : ' + fileExtension.join(', '))
        inputEl.value = ''
      }
    }
  },

  init () {
    const self = this
    const forms = document.querySelectorAll('form[data-formid]')
    forms.forEach(form => {
      self.initForm(form)
      loading(form, false)
    })
  }

}

Forms.init()
